import React, { ReactNode } from 'react';

export interface ThreeColumnLayoutProps {
  children: ReactNode[];
  className?: string;
}

export function ThreeColumnLayout({ children, className = '' }: ThreeColumnLayoutProps) {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ${className}`}>
      {children.map((child, index) => (
        <div
          key={index}
          className={`
            relative
            ${index > 0 ? 'sm:border-l sm:border-border/50' : ''}
            ${index === 2 ? 'sm:border-l-0 md:border-l sm:col-span-2 md:col-span-1 sm:max-w-[50%] md:max-w-none' : ''}
            ${index < children.length - 1 ? 'border-b sm:border-b-0 border-border/50 pb-10 sm:pb-0' : ''}
            pt-6 sm:pt-0
          `}
        >
          <div className="sm:px-6 md:px-8">
            {child}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ThreeColumnLayout;
